import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import styles from '../Video/VideoContainer.module.scss';
import { useTranslation } from 'react-i18next';

type PortalGuideResultProps = {
  searchTerm: string;
  filteredByKeyWordLists: { [key: string]: vp.PortalDocument };
  getSelectedDocument: (doc: vp.PortalDocument) => void;
};

type FC = FunctionComponent<PortalGuideResultProps>;

const { Box } = vp;

const PortalGuideResult: FC = (props: PortalGuideResultProps) => {
  const { searchTerm, filteredByKeyWordLists, getSelectedDocument } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCentre.PDFGuides' });

  return (
    <Box flx="col" gap="md">
      <div className={styles.searchResults}>
        <i>{t('resultsCount', { count: Object.values(filteredByKeyWordLists || {}).length, searchTerm })}</i>
      </div>
      <Box flx="col" gap="ml">
        {Object.values(filteredByKeyWordLists || {}).length > 0 ? (
          <>
            {Object.values(filteredByKeyWordLists || {}).map((doc, index) => {
              const title = doc.title;
              const lowerSearchTerm = searchTerm.toLowerCase();
              const indexOfMatch = title.toLowerCase().indexOf(lowerSearchTerm);

              if (indexOfMatch !== -1) {
                const beforeMatch = title.substring(0, indexOfMatch);
                const match = title.substring(indexOfMatch, indexOfMatch + lowerSearchTerm.length);
                const afterMatch = title.substring(indexOfMatch + lowerSearchTerm.length);

                return (
                  <div
                    key={index}
                    className={styles.searchResultCard}
                    onClick={() => {
                      getSelectedDocument(doc);
                    }}
                  >
                    <div className={styles.label}>{doc.category}</div>
                    <div className={styles.title}>
                      {beforeMatch}
                      <strong>{match}</strong>
                      {afterMatch}
                    </div>
                  </div>
                );
              }
              return <></>;
            })}
          </>
        ) : (
          <div className={styles.message}>{t('noResults')}</div>
        )}
      </Box>
    </Box>
  );
};

export default PortalGuideResult;
